import React from 'react';



export const XfinityHome = ({ height="52px", width="36px",padding="12px",style=''})=> (
<svg className="icon_home_outline" role="presentation" aria-label="" padding={padding} viewBox="0 0 26 22" version="1.1" xmlns="http://www.w3.org/2000/svg">
<g id="Symbols" stroke="none" strokeWidth="1" fill="rgb(97, 56, 245)" fillRule="evenodd">
<g>
<path d="M12,3.86l7.51,5.43V19a1.56,1.56,0,0,1-1.62,1.5H15V14H9v6.51H6.39c-.56,0-1.88-.17-1.88-1.5V9.27L12,3.86M12,2,3,8.5V19c0,3,3.37,3,3.37,3H10.5V15.5h3V22h4.39A3.06,3.06,0,0,0,21,19V8.52L12,2Z"/>
</g>
</g>
</svg>
);
